import BCheckbox from './packages/BCheckbox'

BCheckbox.install = function(Vue) {
    Vue.component(BCheckbox.name, BCheckbox)
}

export default BCheckbox
